import Vue from "vue"
import VueRouter from "vue-router"
import setDocuemntTtitle from "@/utils/setDocumentTitle"
import store from "@/store"

const home = () => import("../views/Home/index")
const userInfo = () => import("../views/UserInfo/index")
const contribute = () => import("../views/Contribute/index")
const myWork = () => import("../views/MyWork/index")
const workDetail = () => import("../views/WorkDetail/index")
const preview = () => import("../views/Preview/index")
const chooseSchool = () => import("../views/ChooseSchool/index")
const nothingnessActivity = () => import("../views/NothingnessActivity/index")
const linkIframe = () => import("../views/LinkIFrame/index")
const workCollection = () => import("../views/WorkCollection/index")
const nothingnessWork = () => import("../views/NothingnessWork/index")
const chooseUnit = () => import("../views/ChooseUnit")
const certGroup = () => import("../views/CertGroup")
const certDetail = () => import("../views/CertDetail")
const myCert = () => import("../views/MyCert")
const myContribute = () => import("../views/MyContribute")
const nothingnessContribute = () => import("../views/NothingnessContribute")

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: "/",
    name: "home",
    meta: {
      title: "",
      keepAlive: true
    },
    component: home
  },
  // 个人信息
  {
    path: "/userInfo",
    name: "userInfo",
    meta: {
      title: "个人信息",
      keepAlive: true
    },
    component: userInfo
  },
  // 投稿
  {
    path: "/contribute",
    name: "contribute",
    meta: {
      title: "投稿",
      keepAlive: false
    },
    component: contribute
  },
  // 我的申报
  {
    path: "/myWork",
    name: "myWork",
    meta: { title: "我的申报" },
    component: myWork
  },
  // 作品详情
  {
    path: "/workDetail",
    name: "workDetail",
    meta: { title: "" },
    component: workDetail
  },
  // 图片预览
  {
    path: "/preview",
    name: "preview",
    meta: { title: "" },
    component: preview
  },
  // 选择学校
  {
    path: "/chooseSchool",
    name: "chooseSchool",
    meta: { title: "选择学校" },
    component: chooseSchool
  },
  {
    path: "/nothingnessActivity",
    name: "nothingnessActivity",
    meta: { title: " " },
    component: nothingnessActivity
  },
  {
    path: "/linkIframe",
    name: "linkIframe",
    meta: { title: " " },
    component: linkIframe
  },
  {
    path: "/workCollection",
    name: "workCollection",
    meta: { title: " " },
    component: workCollection
  },
  {
    path: "/nothingnessWork",
    name: "nothingnessWork",
    meta: { title: "南方报业小记者" },
    component: nothingnessWork
  },
  {
    path: "/chooseUnit",
    name: "chooseUnit",
    meta: { title: "选择单位" },
    component: chooseUnit
  },
  {
    path: "/certGroup",
    name: "certGroup",
    meta: { title: "证书" },
    component: certGroup
  },
  {
    path: "/certDetail",
    name: "certDetail",
    meta: { title: "我的证书" },
    component: certDetail
  },
  {
    path: "/myCert",
    name: "myCert",
    meta: { title: "我的证书" },
    component: myCert
  },
  {
    path: "/myContribute",
    name: "myContribute",
    meta: { title: "我的投稿", keepAlive: true },
    component: myContribute
  },
  {
    path: "/nothingnessContribute",
    name: "nothingnessContribute",
    meta: { title: "我的投稿" },
    component: nothingnessContribute
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  const activityTitle = store.state.activityInfo.activityDetail.activityName
  const title = to.meta.title ? to.meta.title : activityTitle ? activityTitle : ""
  if (title) {
    setDocuemntTtitle(title)
  }
  next()
})

export default router
